var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('share-buttons');
import { breakpoints, theme } from '@shapeable/theme';
import { usePage } from '../../hooks/use-page';
import { useSiteMetadata } from '../../hooks/use-site-metadata';
import { FacebookShareButton } from './facebook-share-button';
import { CopyLinkButton } from './copy-link-button';
import { TwitterShareButton } from './twitter-share-button';
import { LinkedinShareButton } from './linkedin-share-button';
import { sprintf } from 'sprintf-js';
import { EmailShareButton } from './email-share-button';
export var ShareButtonsDefaultProps = {
  include: ['facebook', 'linkedin', 'email', 'link', 'twitter'],
  spacing: 2
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ", "\n  "])), function (_a) {
    var spacing = _a.spacing;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-bottom: -", ";\n    "], ["\n      margin-bottom: -", ";\n    "])), theme.UNIT(spacing));
  })
});
var ButtonStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    cursor: pointer;\n    &:last-child {\n      margin-right: 0;\n    }\n\n    ", "\n  "], ["\n    cursor: pointer;\n    &:last-child {\n      margin-right: 0;\n    }\n\n    ", "\n  "])), function (_a) {
    var spacing = _a.spacing;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin-right: ", ";\n      margin-bottom: ", ";\n    "], ["\n      margin-right: ", ";\n      margin-bottom: ", ";\n    "])), theme.UNIT(spacing), theme.UNIT(spacing));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  FacebookButton: styled(FacebookShareButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  LinkedinButton: styled(LinkedinShareButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  TwitterButton: styled(TwitterShareButton)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  LinkButton: styled(CopyLinkButton)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  EmailButton: styled(EmailShareButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles)
};
export var ShareButtons = function ShareButtons(props) {
  var className = props.className,
      include = props.include,
      onCopy = props.onCopy,
      onCopyDone = props.onCopyDone,
      spacing = props.spacing,
      iconBubbleProps = __rest(props, ["className", "include", "onCopy", "onCopyDone", "spacing"]);

  var page = usePage();
  var site = useSiteMetadata();
  var title = site.title,
      titleTemplate = site.titleTemplate;
  var subject = props.subject || titleTemplate && page.name ? sprintf(titleTemplate, page.name) : page.name ? page.name : title;
  var currentUrl = '';

  if (typeof window !== 'undefined') {
    currentUrl = window.location.href;
  }

  var url = props.url || currentUrl;
  var buttonMap = {
    facebook: React.createElement(My.FacebookButton, __assign({}, iconBubbleProps, {
      spacing: spacing,
      key: "facebook",
      title: "Share on Facebook",
      url: url
    })),
    twitter: React.createElement(My.TwitterButton, __assign({}, iconBubbleProps, {
      spacing: spacing,
      key: "twitter",
      title: "Share on Twitter",
      url: url
    })),
    linkedin: React.createElement(My.LinkedinButton, __assign({}, iconBubbleProps, {
      spacing: spacing,
      key: "linkedin",
      title: "Share on Linkedin",
      url: url
    })),
    link: React.createElement(My.LinkButton, __assign({}, iconBubbleProps, {
      spacing: spacing,
      key: "link",
      url: url,
      onCopy: onCopy,
      onCopyDone: onCopyDone,
      title: "Copy link to clipboard"
    })),
    email: React.createElement(My.EmailButton, __assign({}, iconBubbleProps, {
      spacing: spacing,
      key: "email",
      subject: subject,
      title: "Share via email",
      url: url
    }))
  };
  return React.createElement(My.Container, {
    spacing: spacing,
    className: cls.name(className)
  }, include.map(function (key) {
    return buttonMap[key];
  }));
};
ShareButtons.defaultProps = ShareButtonsDefaultProps;
ShareButtons.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;